(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glowinex-assistant-analytics"]) return;
  try {
    
(() => {
  if (window.__glxSignalLayerV2) return;
  window.__glxSignalLayerV2 = true;

  const ROOT_SELECTOR = '[data-gx-assistant-analytics]';
  const CHAT_SELECTOR = '[data-chat]';
  const SESSION_KEY = 'gx_signal_session_v2';
  const BUFFER_KEY = 'gx_signal_buffer_v2';
  const MAX_BUFFER = 60;
  const ENDPOINT_BATCH_SIZE = 5;
  const root = document.querySelector(ROOT_SELECTOR);
  if (!root) return;

  const debug = root.dataset.debug === 'true';
  const shopifyBridge = root.dataset.shopifyBridge !== 'false';
  const gtagBridge = root.dataset.gtagBridge !== 'false';
  const endpoint = String(root.dataset.endpoint || '').trim();

  const log = (...args) => {
    if (debug && window.console && typeof console.debug === 'function') {
      console.debug('[Glowinex Signals]', ...args);
    }
  };

  const analyticsAllowed = () => {
    try {
      const privacy = window.Shopify && window.Shopify.customerPrivacy;
      return !!(
        privacy &&
        typeof privacy.analyticsProcessingAllowed === 'function' &&
        privacy.analyticsProcessingAllowed() === true
      );
    } catch (_) {
      return false;
    }
  };

  const safeToken = (value, fallback = 'event') => {
    const token = String(value || '')
      .toLowerCase()
      .replace(/[^a-z0-9_-]+/g, '_')
      .replace(/^_+|_+$/g, '')
      .slice(0, 64);
    return token || fallback;
  };

  const cleanPath = (value) => {
    try {
      const url = new URL(value, window.location.origin);
      return (url.pathname + url.search).slice(0, 300);
    } catch (_) {
      return '';
    }
  };

  const cleanString = (value, max = 160) =>
    String(value == null ? '' : value).replace(/\s+/g, ' ').trim().slice(0, max);

  const compact = (detail) => {
    const out = {};
    Object.entries(detail || {}).forEach(([key, value]) => {
      if (value == null || value === '') return;
      if (typeof value === 'string') out[key] = cleanString(value);
      else if (typeof value === 'number' && Number.isFinite(value)) out[key] = value;
      else if (typeof value === 'boolean') out[key] = value;
    });
    return out;
  };

  const readBuffer = () => {
    if (!analyticsAllowed()) return [];
    try {
      const parsed = JSON.parse(sessionStorage.getItem(BUFFER_KEY) || '[]');
      return Array.isArray(parsed) ? parsed.slice(-MAX_BUFFER) : [];
    } catch (_) {
      return [];
    }
  };

  const writeBuffer = (events) => {
    if (!analyticsAllowed()) return;
    try {
      sessionStorage.setItem(BUFFER_KEY, JSON.stringify(events.slice(-MAX_BUFFER)));
    } catch (_) {}
  };

  const makeId = () => {
    try {
      if (window.crypto && typeof window.crypto.randomUUID === 'function') {
        return window.crypto.randomUUID();
      }
    } catch (_) {}
    return Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 12);
  };

  const sessionId = () => {
    if (!analyticsAllowed()) return '';
    try {
      let id = sessionStorage.getItem(SESSION_KEY);
      if (!id) {
        id = makeId();
        sessionStorage.setItem(SESSION_KEY, id);
      }
      return id;
    } catch (_) {
      return makeId();
    }
  };

  const deviceBucket = () => {
    const width = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
    if (width < 750) return 'mobile';
    if (width < 1100) return 'tablet';
    return 'desktop';
  };

  const referrerHost = () => {
    try {
      if (!document.referrer) return '';
      return new URL(document.referrer).hostname.slice(0, 120);
    } catch (_) {
      return '';
    }
  };

  const baseContext = () => ({
    pageType: cleanString(root.dataset.pageType || 'unknown', 40),
    pagePath: cleanPath(window.location.href),
    productId: cleanString(root.dataset.productId || '', 40),
    productHandle: cleanString(root.dataset.productHandle || '', 120),
    collectionHandle: cleanString(root.dataset.collectionHandle || '', 120),
    locale: cleanString(root.dataset.locale || document.documentElement.lang || '', 20),
    currency: cleanString(root.dataset.currency || '', 12),
    device: deviceBucket(),
    referrerHost: referrerHost()
  });

  let sequence = 0;
  let endpointQueue = [];
  let flushTimer = 0;

  const sendEndpointBatch = (reason = 'batch') => {
    if (!endpoint || !analyticsAllowed() || !endpointQueue.length) return false;
    const events = endpointQueue.splice(0, 20);
    const body = JSON.stringify({
      schemaVersion: 2,
      source: 'glowinex_signal',
      reason,
      sessionId: sessionId(),
      events
    });

    let sent = false;
    try {
      if (navigator.sendBeacon) {
        sent = navigator.sendBeacon(endpoint, new Blob([body], { type: 'application/json' }));
      }
    } catch (_) {}

    if (!sent) {
      try {
        fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body,
          keepalive: true,
          credentials: 'same-origin'
        }).catch(() => {});
        sent = true;
      } catch (_) {}
    }

    log('endpoint batch', reason, events.length, sent);
    return sent;
  };

  const scheduleEndpointFlush = () => {
    if (!endpoint || flushTimer) return;
    flushTimer = window.setTimeout(() => {
      flushTimer = 0;
      sendEndpointBatch('timer');
    }, 10000);
  };

  const publish = (name, detail = {}) => {
    if (!analyticsAllowed()) return false;

    const eventName = safeToken(name);
    const payload = {
      schemaVersion: 2,
      event: eventName,
      source: 'glowinex_signal',
      sessionId: sessionId(),
      sequence: ++sequence,
      occurredAt: new Date().toISOString(),
      ...baseContext(),
      ...compact(detail)
    };

    const buffer = readBuffer();
    buffer.push(payload);
    writeBuffer(buffer);

    try {
      document.dispatchEvent(new CustomEvent('glowinex:analytics', { detail: payload }));
    } catch (_) {}

    if (shopifyBridge) {
      try {
        if (
          window.Shopify &&
          window.Shopify.analytics &&
          typeof window.Shopify.analytics.publish === 'function'
        ) {
          Promise.resolve(
            window.Shopify.analytics.publish('glowinex_signal:' + eventName, payload)
          ).catch(() => {});
        }
      } catch (_) {}
    }

    if (gtagBridge) {
      try {
        if (typeof window.gtag === 'function') {
          window.gtag('event', 'glowinex_signal_' + eventName, payload);
        }
      } catch (_) {}

      try {
        if (Array.isArray(window.dataLayer)) {
          window.dataLayer.push({
            event: 'glowinex_signal',
            glowinex_event: eventName,
            glowinex: payload
          });
        }
      } catch (_) {}
    }

    if (endpoint) {
      endpointQueue.push(payload);
      if (endpointQueue.length >= ENDPOINT_BATCH_SIZE) sendEndpointBatch('size');
      else scheduleEndpointFlush();
    }

    log(eventName, payload);
    return true;
  };

  window.GlowinexAnalytics = {
    version: '2.0',
    track: publish,
    snapshot: () => readBuffer().slice(),
    flush: () => sendEndpointBatch('manual'),
    consent: analyticsAllowed
  };

  const classifyAssistantMessage = (value) => {
    const s = String(value || '').toLowerCase();
    if (/(refund|return|money back|vissza|elallas|elállás|visszater|visszatér)/.test(s)) return 'returns';
    if (/(damaged|broken|faulty|wrong item|missing item|serult|sérült|hibas|hibás|hiányos|hianyos)/.test(s)) return 'damaged';
    if (/(track|where.*order|where.*package|order status|csomagom|rendelesem|rendelésem|hol van)/.test(s)) return 'tracking';
    if (/(shipping|delivery|szallitas|szállítás|kezbesites|kézbesítés)/.test(s)) return 'shipping';
    if (/(recommend|which light|choose|ajanl|ajánl|melyik lampa|melyik lámpa|gaming|floor lamp|wall panel|neon|led strip)/.test(s)) return 'recommendation';
    if (/(support|contact|ember|ugyfelszol|ügyfélszol|kapcsolat)/.test(s)) return 'contact';
    return 'other';
  };

  const decorateAssistantContact = () => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('gx_source') !== 'assistant') return;
    const form = document.querySelector('#ContactForm');
    if (!form || form.dataset.gxAssistantSource === '1') return;
    form.dataset.gxAssistantSource = '1';

    const addHidden = (name, value) => {
      let input = Array.from(form.querySelectorAll('input[type="hidden"]')).find((node) => node.name === name);
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        form.appendChild(input);
      }
      input.value = cleanString(value, 80);
    };

    addHidden('contact[Source]', 'Glowinex Assistant');
    addHidden('contact[Assistant topic]', safeToken(params.get('gx_topic') || 'contact'));
    addHidden('contact[Assistant language]', root.dataset.locale || document.documentElement.lang || '');
    publish('assistant_contact_view', { topic: safeToken(params.get('gx_topic') || 'contact') });
  };

  const bindAssistant = () => {
    const chat = document.querySelector(CHAT_SELECTOR);
    if (!chat || chat.dataset.gxSignalBound === '1') return false;
    chat.dataset.gxSignalBound = '1';
    let lastIntent = '';

    chat.addEventListener('click', (event) => {
      const target = event.target instanceof Element ? event.target : null;
      if (!target) return;

      const teaser = target.closest('.gx-assistant-teaser');
      if (teaser && chat.contains(teaser)) {
        publish('assistant_teaser_click');
        publish('assistant_open', { entry: 'teaser' });
        return;
      }

      const launcher = target.closest('[data-open]');
      if (launcher && chat.contains(launcher)) {
        if (event.isTrusted) publish('assistant_open', { entry: 'launcher' });
        return;
      }

      const close = target.closest('[data-close]');
      if (close && chat.contains(close)) {
        publish('assistant_close');
        return;
      }

      const intent = target.closest('[data-intent]');
      if (intent && chat.contains(intent)) {
        lastIntent = safeToken(intent.dataset.intent || 'unknown', 'unknown');
        publish('assistant_intent', { intent: lastIntent });
        return;
      }

      const link = target.closest('a[href]');
      if (!link || !chat.contains(link)) return;
      const href = link.getAttribute('href') || '';
      if (href.includes('/pages/contact') || href.toLowerCase().startsWith('mailto:')) {
        publish('assistant_support_click', { context: lastIntent || 'contact' });
      } else if (href.includes('/products/')) {
        publish('assistant_product_click', { productPath: cleanPath(href) });
      } else if (href.includes('/pages/track-order')) {
        publish('assistant_tracking_click', { context: lastIntent || 'tracking' });
      }
    }, { capture: true });

    const form = chat.querySelector('[data-form]');
    const input = chat.querySelector('[data-input]');
    if (form && input) {
      form.addEventListener('submit', () => {
        const category = lastIntent === 'track' ? 'tracking' : classifyAssistantMessage(input.value || '');
        publish('assistant_message_sent', { category });
        if (category !== 'other') lastIntent = category;
      }, { capture: true });
    }

    return true;
  };

  const bindCommercePubSub = () => {
    if (window.__glxSignalPubSubBound) return true;
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return false;

    window.__glxSignalPubSubBound = true;

    try {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        const cart = event && event.cartData ? event.cartData : {};
        publish('cart_update', {
          cartSource: cleanString(event && event.source ? event.source : '', 60),
          itemCount: Number(cart.item_count || 0),
          totalPrice: Number(cart.total_price || 0),
          variantId: cleanString(event && event.variantId ? event.variantId : '', 40)
        });
      });
    } catch (_) {}

    try {
      subscribe(PUB_SUB_EVENTS.cartError, (event) => {
        publish('cart_error', {
          cartSource: cleanString(event && event.source ? event.source : '', 60),
          variantId: cleanString(event && event.productVariantId ? event.productVariantId : '', 40)
        });
      });
    } catch (_) {}

    return true;
  };

  const bindGlobalSignals = () => {
    if (document.documentElement.dataset.gxSignalsBound === '1') return;
    document.documentElement.dataset.gxSignalsBound = '1';

    document.addEventListener('click', (event) => {
      const target = event.target instanceof Element ? event.target : null;
      if (!target) return;

      const checkout = target.closest('button[name="checkout"], input[name="checkout"], a[href*="/checkout"]');
      if (checkout) {
        publish('checkout_start', { entry: checkout.tagName.toLowerCase() });
        return;
      }

      // Intent signals are not purchase-confirmation signals.
      if (target.closest('[data-glx-discovery-clear]')) {
        publish('filter_reset', { location: 'collection' });
        return;
      }
      if (target.closest('[data-glx-discovery-chips] .glx-discovery__chip')) {
        publish('filter_chip_removed', { location: 'collection' });
        return;
      }
      if (target.closest('[data-glx-bundle-launch-v10e], #glx-bundle-launch-v9')) {
        publish('bundle_builder_open');
        return;
      }
      if (target.closest('[data-glx-bundle-drawer="v10e"] .glx-add')) {
        publish('bundle_add_intent');
        return;
      }
      if (target.closest(CHAT_SELECTOR)) return;

      const productLink = target.closest('a[href*="/products/"]');
      if (productLink) {
        publish('product_click', { productPath: cleanPath(productLink.href) });
        return;
      }

      const collectionLink = target.closest('a[href*="/collections/"]');
      if (collectionLink) {
        publish('collection_click', { collectionPath: cleanPath(collectionLink.href) });
      }
    }, { capture: true });

    document.addEventListener('submit', (event) => {
      const form = event.target instanceof HTMLFormElement ? event.target : null;
      if (!form) return;
      const action = form.getAttribute('action') || '';

      if (action.includes('/search')) {
        const query = form.querySelector('input[name="q"]')?.value || '';
        publish('search_submit', { query: cleanString(query, 80), queryLength: query.length });
      } else if (action.includes('/cart/add')) {
        publish('add_to_cart_intent', { source: 'product_form' });
      }
    }, { capture: true });

    document.addEventListener('change', (event) => {
      const input = event.target instanceof Element ? event.target : null;
      if (!input) return;
      if (input.closest('[data-glx-discovery-filters]') && input.matches('input[type="checkbox"]')) {
        publish('collection_filter_change', {
          facet: cleanString(input.dataset.key || 'other', 30),
          selected: input.checked
        });
        return;
      }
      if (input.closest('[data-glx-search-tools-v1]') && input.matches('select, input[type="number"]')) {
        const labels = ['family','availability','finish','sort','min','max'];
        const control = labels.find(name => input.hasAttribute('data-glx-st-' + name)) || 'other';
        publish('search_refinement', { control });
        return;
      }
      if (input.closest('#glx-compare-v1') && input.matches('select, input[type="checkbox"]')) {
        publish('comparison_change', { control: cleanString(input.name || input.id || 'options', 50) });
        return;
      }
      if (input.closest('#MainContent variant-selects') && input.matches('select, input[type="radio"]')) {
        publish('variant_option_change');
      }
    }, { capture: true });

    document.addEventListener('glx:byl:cart-synced', () => publish('bundle_cart_sync'));

    const scrollMarks = new Set();
    const onScroll = () => {
      const height = document.documentElement.scrollHeight - window.innerHeight;
      if (height <= 0) return;
      const depth = Math.round((window.scrollY / height) * 100);
      [50, 90].forEach((mark) => {
        if (depth >= mark && !scrollMarks.has(mark)) {
          scrollMarks.add(mark);
          publish('scroll_depth', { depth: mark });
        }
      });
      if (scrollMarks.size === 2) window.removeEventListener('scroll', onScroll);
    };
    window.addEventListener('scroll', onScroll, { passive: true });

    let activeSeconds = 0;
    const engagementMarks = new Set();
    window.setInterval(() => {
      if (document.visibilityState !== 'visible') return;
      activeSeconds += 1;
      [30, 60, 120].forEach((mark) => {
        if (activeSeconds >= mark && !engagementMarks.has(mark)) {
          engagementMarks.add(mark);
          publish('engaged_time', { seconds: mark });
        }
      });
    }, 1000);
  };

  const publishPageContext = () => {
    const pageKey = cleanPath(window.location.href);
    if (window.__glxSignalLastPage === pageKey) return;
    window.__glxSignalLastPage = pageKey;

    publish('page_view');

    const pageType = root.dataset.pageType || '';
    if (pageType === 'product') publish('product_view');
    if (pageType === 'collection') publish('collection_view');
    if (pageType === 'search') {
      const query = new URLSearchParams(window.location.search).get('q') || '';
      publish('search_view', { query: cleanString(query, 80), queryLength: query.length });
    }
  };

  const bindHistory = () => {
    if (window.__glxSignalHistoryBound) return;
    window.__glxSignalHistoryBound = true;
    ['pushState', 'replaceState'].forEach((name) => {
      const original = history[name];
      if (typeof original !== 'function') return;
      history[name] = function() {
        const result = original.apply(this, arguments);
        window.setTimeout(publishPageContext, 0);
        return result;
      };
    });
    window.addEventListener('popstate', () => window.setTimeout(publishPageContext, 0));
  };

  const boot = () => {
    if (!analyticsAllowed()) return;
    const existing = readBuffer();
    if (!existing.some((item) => item && item.event === 'session_start' && item.sessionId === sessionId())) {
      publish('session_start', { firstEvent: existing.length === 0 });
    }
    publishPageContext();
    decorateAssistantContact();
    bindAssistant();
    bindGlobalSignals();
    bindHistory();

    if (!bindCommercePubSub()) {
      let attempts = 0;
      const retry = window.setInterval(() => {
        attempts += 1;
        if (bindCommercePubSub() || attempts >= 12) window.clearInterval(retry);
      }, 250);
    }
  };

  const bootWithPrivacy = () => {
    if (window.Shopify && window.Shopify.customerPrivacy) {
      boot();
      return;
    }
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures(
        [{ name: 'consent-tracking-api', version: '0.1' }],
        () => boot()
      );
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootWithPrivacy, { once: true });
  } else {
    bootWithPrivacy();
  }

  document.addEventListener('visitorConsentCollected', boot);
  document.addEventListener('shopify:section:load', () => {
    decorateAssistantContact();
    bindAssistant();
    bindCommercePubSub();
  });

  window.addEventListener('pagehide', () => {
    if (flushTimer) window.clearTimeout(flushTimer);
    sendEndpointBatch('pagehide');
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glowinex-collection-directory"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-gx-collection-select]').forEach(function(select){if(select.dataset.gxBound==='true')return;select.dataset.gxBound='true';select.addEventListener('change',function(){if(this.value)window.location.assign(this.value);});});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glowinex-ui-scope"]) return;
  try {
    
(() => {
  const bindAssistantTeaser = () => {
    const chat = document.querySelector('[data-chat]');
    if (!chat) return;

    const open = chat.querySelector('[data-open]');
    const panel = chat.querySelector('[data-panel]');
    if (!open || !panel || open.dataset.teaserBound === '1') return;
    open.dataset.teaserBound = '1';

    const hu = (document.documentElement.lang || '').toLowerCase().startsWith('hu');
    const reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const designMode = !!(window.Shopify && window.Shopify.designMode);
    const storageKey = 'gx_assistant_teaser_seen_v1';

    const teaser = document.createElement('button');
    teaser.type = 'button';
    teaser.className = 'gx-assistant-teaser';
    teaser.setAttribute('aria-label', hu ? 'Glowinex Assistant megnyitása' : 'Open Glowinex Assistant');

    const text = document.createElement('span');
    text.textContent = hu ? 'Szia! Miben segíthetek?' : 'Hi! How can I help you?';
    teaser.appendChild(text);
    chat.appendChild(teaser);

    let showTimer = null;
    let hideTimer = null;
    let restoreTimer = null;

    const markSeen = () => {
      if (designMode) return;
      try { window.sessionStorage.setItem(storageKey, '1'); } catch (_) {}
    };

    const hasSeen = () => {
      if (designMode) return false;
      try { return window.sessionStorage.getItem(storageKey) === '1'; } catch (_) { return false; }
    };

    const clearTimers = () => {
      if (showTimer) window.clearTimeout(showTimer);
      if (hideTimer) window.clearTimeout(hideTimer);
      if (restoreTimer) window.clearTimeout(restoreTimer);
      showTimer = null;
      hideTimer = null;
      restoreTimer = null;
    };

    const pauseInactivityTimer = () => {
      if (hideTimer) window.clearTimeout(hideTimer);
      hideTimer = null;
    };

    const hideTeaser = (restoreLauncher = true) => {
      teaser.classList.remove('is-visible');
      pauseInactivityTimer();

      if (restoreLauncher) {
        if (restoreTimer) window.clearTimeout(restoreTimer);
        restoreTimer = window.setTimeout(() => {
          if (!panel.classList.contains('on')) {
            open.classList.remove('gx-launcher-hidden');
          }
        }, 360);
      }
    };

    const restartInactivityTimer = () => {
      pauseInactivityTimer();
      if (!teaser.classList.contains('is-visible')) return;
      hideTimer = window.setTimeout(() => hideTeaser(true), 10000);
    };

    const showTeaser = () => {
      if (panel.classList.contains('on') || document.hidden) return;
      open.classList.add('gx-launcher-hidden');
      teaser.classList.add('is-visible');
      markSeen();
      restartInactivityTimer();
    };

    teaser.addEventListener('pointerenter', pauseInactivityTimer);
    teaser.addEventListener('pointerleave', restartInactivityTimer);
    teaser.addEventListener('focus', pauseInactivityTimer);
    teaser.addEventListener('blur', restartInactivityTimer);

    teaser.addEventListener('click', () => {
      clearTimers();
      teaser.classList.remove('is-visible');
      open.classList.remove('gx-launcher-hidden');
      markSeen();
      window.requestAnimationFrame(() => open.click());
    });

    open.addEventListener('click', () => {
      clearTimers();
      teaser.classList.remove('is-visible');
      open.classList.remove('gx-launcher-hidden');
      markSeen();
    }, { capture: true });

    const closeButton = chat.querySelector('[data-close]');
    if (closeButton) {
      closeButton.addEventListener('click', () => {
        open.classList.remove('gx-launcher-hidden');
      });
    }

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) hideTeaser(true);
    });

    if (!reduced && !hasSeen()) {
      showTimer = window.setTimeout(showTeaser, 2000);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindAssistantTeaser, { once: true });
  } else {
    bindAssistantTeaser();
  }

  document.addEventListener('shopify:section:load', bindAssistantTeaser);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
